import { useTranslation } from 'react-i18next';
import { Head } from '~/components/shared/Head';
import { useParams } from 'react-router-dom';
import { TrainingSettings } from './components/TrainingSettings';
import { MemoriesModule } from './components/MemoriesModule';

const Training = () => {
  const [t] = useTranslation('training_settings');
  const { agentId } = useParams();

  if (!agentId) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-red-500">Agent ID is required</div>
      </div>
    );
  }

  return (
    <div className="m-auto w-full max-w-[1200px] px-8 pt-12">
      <Head title={t('training_title')} />
      <h1 className="text-2xl font-medium">{t('training_title')}</h1>
      <p className="mt-2 text-gray-600">{t('training_description')}</p>

      <div className="mt-8 space-y-8">
        {/* Training Settings Section */}
        <div className="rounded-2xl bg-base-100 p-6">
          <TrainingSettings />
        </div>

        {/* Memories Module Section */}
        <div className="rounded-2xl bg-base-100">
          <MemoriesModule agentId={agentId} />
        </div>
      </div>
    </div>
  );
};

export default Training;
